/**
 * [resp-img]
 * responsive images via data-resp-img-* attributes
 */
window.coma = window.coma || {};

window.coma.respImg = (function ($, undefined) {

    // PRIVATE FUNCTIONS
    var _private = {

        init: function() {
            // listen to mediaqueries-changed
            $(document).on('mediaqueries-changed', function(e) {
                // the new mediaquery (xs, sm, md, lg) is stored in e.message
                _private.setRespImgSrc(e.message);
            });

            // initially do it once
            _private.setRespImgSrc(window.coma.mediaqueries.getDevice());
        },
        setRespImgSrc: function(mediaquery) {
        
            // select all images with data-resp-img attribute (the default src)
            var images = $('img[data-resp-img]');
            
            if(mediaquery.charAt(0) === "'"){
                mediaquery = mediaquery.substr(1,2);
            }
            
            $.each(images, function(i, img) {
                // try to get specific attribute data-resp-img-*
                var newSrc = $(img).attr('data-resp-img-' + mediaquery);

                if (typeof newSrc != 'undefined') {
                    // if specific img exists, set new src
                    $(img).attr('src', newSrc);
                }
                else {
                    // else the unspecific data-resp-img is always the default
                    $(img).attr('src', $(img).attr('data-resp-img'));
                }
            });
        }
    }

    // CALL INIT
    $(document).ready(function() {
        _private.init();
    });

    // PUBLIC FUNCTIONS
    return {}

}(jQuery));